import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Container } from '../../ui/Container';
import { Button } from '../../ui/Button';
const items = [{
  title: 'Annual Programs',
  desc: '',
  img: 'https://cdn.magicpatterns.com/uploads/2oyAijm6fxaEJiR4qbNAKH/AnnualPrograms6.jpg',
  cta: 'Explore',
  to: '/en/adults/annual-programs'
}, {
  title: 'Core Courses',
  desc: '',
  img: 'https://cdn.magicpatterns.com/uploads/1KJnu5Mw1PZbQZTNxTbn3x/CoreCourses3.jpg',
  cta: 'Browse',
  to: '/en/adults/core-courses'
}, {
  title: 'Professional Development',
  desc: '',
  img: 'https://cdn.magicpatterns.com/uploads/mZ6s4PwoMdkaamZH9rLkBU/Prof-Dev.jpg',
  cta: 'View',
  to: '/en/adults/professional-development'
}, {
  title: 'Creative Learning',
  desc: '',
  img: 'https://cdn.magicpatterns.com/uploads/ninMqHXNBrWb99GzWxD16c/Creative2.jpg',
  cta: 'Discover',
  to: '/en/adults/creative-learning'
}];
export function ForAdults() {
  return <section className="relative py-20 md:py-28 overflow-hidden bg-sand-50/60" data-id="element-601" data-mp="38rbdal2g6xyi">
      <Container data-id="element-602" data-mp="34qhm9itpl31e">
        <div className="text-center max-w-3xl mx-auto" data-id="element-603" data-mp="34r15d2v3hxh0">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white text-sand-500 text-[11px] font-semibold tracking-[0.14em] uppercase border border-sand-300/50" data-id="element-604" data-mp="3ih4i93834ets">
            For Adults
          </span>
          <h2 className="font-display text-3xl md:text-5xl text-ink-900 leading-tight mt-5" data-id="element-605" data-mp="3sdg34hlqqczu">
            Education For Responsible Participation
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-606" data-mp="5ab8bt3uf3ez">
          {items.map((item, i) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex flex-col bg-white rounded-2xl overflow-hidden shadow-card hover:shadow-[0_24px_60px_-20px_rgba(14,27,46,0.18)] transition-shadow" data-id="element-607" data-mp="c9r7dpz9e65" data-mpi={i}>
              <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden" data-id="element-608" data-mp="oykngk6si6hj">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover" data-id="element-609" data-mp="twvt0iq1xuty" />
              </div>
              <div className="p-5 flex flex-col items-center text-center gap-3 flex-1 justify-between" data-id="element-610" data-mp="13myy3hag6z8n">
                <h3 className="font-display text-base md:text-lg text-ink-900" data-id="element-611" data-mp="17ok3yioked9c">
                  {item.title}
                </h3>
                <Link to={item.to} data-id="element-612" data-mp="1coop4m0f3w5w">
                  <Button variant="primary" size="sm" data-id="element-613" data-mp="1cnww9iy7gcjb">
                    {item.cta}
                  </Button>
                </Link>
              </div>
            </motion.div>)}
        </div>

        <div className="relative mt-14 rounded-3xl bg-forest-700 text-ivory text-center py-12 md:py-14 px-6 shadow-card overflow-hidden bg-cover bg-center" style={{
        backgroundImage: "url('https://cdn.magicpatterns.com/uploads/9YPK89mwYRQBaNVVDfCqxu/cta-five_bg2.png')"
      }} data-id="element-614" data-mp="2s8pdi543onmi">
          <div className="absolute inset-0 bg-forest-700/30" aria-hidden="true" data-id="element-615" data-mp="3bu26kni27yvz" />
          <div className="relative" data-id="element-616" data-mp="372tvln1305gp">
            <h3 className="font-display text-2xl md:text-3xl" data-id="element-617" data-mp="371r4pf3re30s">
              Accessing Islamic Knowledge
              <br data-id="element-618" data-mp="322o7uhxxn33w" />
              Shouldn't be a Luxury
            </h3>
            <p className="mt-4 max-w-2xl mx-auto text-ivory/85 leading-relaxed" data-id="element-619" data-mp="3gbnhdr7nito">
              Join our initiative to fund scholarships for children of
              determination and children from families facing hardships in
              non-Muslim countries.
            </p>
            <div className="mt-6" data-id="element-620" data-mp="3je313pptowqq">
              <Link to="/en/partnership/become-a-partner" data-id="element-621" data-mp="3jebc1c2dxrza">
                <Button variant="gold" data-id="element-622" data-mp="35e0jm4lfg5c0">Become A Partner</Button>
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}